import React from 'react';
import {
  Typography, Box, useTheme, alpha,
  Button,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import heroImg from '../../../assets/shopping_hero.png';
import bancameLogo from '../../../assets/bancame_logo_white.svg';
import HeroCard from '../../../components/HeroCard';

export default function ShoppingRedirectCard() {
  const history = useHistory();
  const theme = useTheme();

  const handleRedirect = () => {
    history.push('/account/bnpl');
  };
  const gradient = `linear-gradient(100deg, ${alpha(theme.palette.secondary.main, 0.7)} 0%, ${alpha(theme.palette.primary.main, 0.8)} 33%, ${alpha(theme.palette.secondary.main, 0.5)} 70%, ${alpha(theme.palette.tertiary.main, 0.7)} 100%)`;

  return (
    <HeroCard
      heroImage={heroImg}
      overlayGradient={gradient}
      onConfirm={handleRedirect}
      buttonText="Ir a compras"
      logo={(
        <Box
          component="img"
          src={bancameLogo}
          alt="banca.me"
          sx={{
            height: 15, width: 'auto', display: 'block', mb: 2.5,
          }}
        />
      )}
      title={(
        <Typography
          variant="h5"
          color="white.main"
          sx={{
            fontWeight: 800,
            letterSpacing: '-0.8px',
            lineHeight: 1.1,
          }}
        >
          Compra en cuotas y sin tarjetas con banca.me
        </Typography>
      )}
      body={(
        <Typography
          variant="body2"
          color="white.main"
          sx={{
            lineHeight: 1.5,
            maxWidth: { xs: '100%', md: '70%' },
          }}
        >
          Conoce tu
          {' '}
          <b>poder de compra</b>
          {' '}
          disponible y los comercios donde puedes comprar.
          También verás tus compras y movimientos realizados con banca.me
        </Typography>
      )}
      button={(
        <Button variant="contained" color="secondary" sx={{ borderRadius: 5, minWidth: 140, width: 'fit-content' }}>
          Ir a compras
        </Button>
      )}
    />
  );
}
